export function generateHexCodeColor(): string {
  const hexCode: string[] = [];
  for (let i = 0; i < 6; i++) {
    hexCode.push(Math.floor(Math.random() * 16).toString(16));
  }
  return `#${hexCode.join("")}`;
}
